var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M31.795 15.897c0 8.78-7.118 15.897-15.898 15.897S0 24.677 0 15.897C0 7.117 7.117 0 15.897 0c8.78 0 15.898 7.117 15.898 15.897",
    transform: "translate(-315 -1271) translate(39 1271) translate(276)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3742",
    d: "M14.53 18.118c0 1.61-1.104 2.916-2.467 2.916-1.362 0-2.467-1.306-2.467-2.916 0-1.61 1.105-2.916 2.467-2.916 1.363 0 2.467 1.306 2.467 2.916M26.864 18.791c0 1.61-1.104 2.915-2.466 2.915s-2.468-1.305-2.468-2.915 1.106-2.915 2.468-2.915c1.362 0 2.466 1.305 2.466 2.915M22.378 28.506c-.374 0-.697-.282-.739-.662-.008-.04-.294-1.488-3.426-2.042-3.339-.587-5.769 2.394-5.793 2.424-.257.322-.726.373-1.046.117-.321-.257-.373-.726-.116-1.046.12-.151 3.012-5.19 7.214-4.448 4.312.761 4.635 4.725 4.647 4.83.045.41-.25.777-.658.822l-.083.005M5.334 13.704c-.375 0-.698-.283-.739-.665-.043-.41.253-.776.662-.82.04-.003 4.112-.455 6.83-2.338.339-.234.802-.15 1.037.189.233.337.15.801-.189 1.035-3.037 2.103-7.34 2.576-7.522 2.595l-.079.004M29.108 14.825l-.106-.008c-3.437-.49-5.59-3.78-5.68-3.921-.221-.346-.121-.805.223-1.028.346-.222.806-.124 1.029.222.02.028 1.883 2.861 4.639 3.254.406.059.69.435.631.842-.053.372-.371.639-.736.639",
    transform: "translate(-315 -1271) translate(39 1271) translate(276)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7EB2EA",
    d: "M28.682 27.325c0 1.398-1.051 2.532-2.347 2.532s-2.346-1.134-2.346-2.532c0-1.398 2.346-4.63 2.346-4.63s2.347 3.232 2.347 4.63",
    transform: "translate(-315 -1271) translate(39 1271) translate(276)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionSad);
export default __webpack_public_path__ + "static/media/reactionSad.96ba3c8f.svg";
export { ForwardRef as ReactComponent };